import { render } from "./AuthBrandPanel.vue?vue&type=template&id=ac4c8458&scoped=true"
import script from "./AuthBrandPanel.vue?vue&type=script&lang=js"
export * from "./AuthBrandPanel.vue?vue&type=script&lang=js"

import "./AuthBrandPanel.vue?vue&type=style&index=0&id=ac4c8458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4c8458"]])

export default __exports__